import { Injectable } from '@angular/core';
import { UIDialogService } from '@bannerflow/ui';
import { DuplicateCreativeDialogComponent } from './duplicate-creative-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class DuplicateCreativeService {
    constructor(private dialogService: UIDialogService) {}

    openDialog(duplicateToNew: boolean): void {
        const headerText = duplicateToNew
            ? 'Duplicate creatives to new creative set'
            : 'Duplicate creatives to existing creative set';

        this.dialogService.openComponent(DuplicateCreativeDialogComponent, {
            headerText: headerText,
            panelClass: ['no-padding', 'fullscreen'],
            maxWidth: '100%',
            width: '100%',
            height: '100%',
            data: {
                duplicateToNew
            }
        });
    }
}
